export const enum ItemTypeConstants {
  STATIC_ITEMS = 'STATIC',
  DYNAMIC_ITEMS = 'DYNAMIC',
}
